import React, {useState} from 'react'
import {LocalLink} from 'i18n/LocalLink'
import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {routes} from 'routes/routes'
import {useI18n} from 'i18n/I18nContext'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import LogoutIcon from '@mui/icons-material/Logout'
import Avatar from 'react-avatar'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import DescriptionIcon from '@mui/icons-material/Description'

export const ProfileLinks = () => {
  const {t} = useI18n()
  const {logout, user} = useAuth()

  const [userDropdown, setuserDropdown] = useState<boolean>(false)

  const handleShowuserDrowdown = () => {
    setuserDropdown(!userDropdown)
  }

  return (
    <>
      <div className="nav-item p-relative">
        <button id="userportfolio" onClick={handleShowuserDrowdown}>
          <div className="user__portfolio">
            <div className="user__portfolio-thumb">
              <Avatar
                name={user?.first_name + ' ' + user?.last_name}
                round={true}
                size="50"
                textSizeRatio={3}
              />
            </div>

            <div className="user__content">
              <span>
                {user?.first_name} {user?.last_name}
              </span>
            </div>
          </div>
        </button>
        <div className={`user__dropdown ${userDropdown ? 'user-enable' : ' '}`}>
          <ul>
            <li>
              <LocalLink to={routes.profile}>
                <AccountBoxIcon /> {t('nav.profile')}{' '}
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.tickets}>
                <ConfirmationNumberIcon /> {t('nav.tickets')}{' '}
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.certificates}>
                <WorkspacePremiumIcon /> {t('nav.certificates')}{' '}
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.purchases}>
                <ShoppingCartIcon /> {t('nav.purchases')}{' '}
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.billing}>
                <CreditCardIcon />
                {t('nav.payments')}
              </LocalLink>
            </li>
            <li>
              <LocalLink to={routes.invoices}>
                <DescriptionIcon />
                {t('nav.billing')}
              </LocalLink>
            </li>

            <li>
              <LocalLink to={routes.organization.login}>
                <CorporateFareIcon />
                {t('nav.orgLogin')}
              </LocalLink>
            </li>
            <li>
              <button type="button" onClick={logout}>
                <LogoutIcon />
                {t('nav.logout')}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
